import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import logo from "../assets/logo.png";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const navItems = [
    { label: "Home", item: "home" },
    { label: "About Us", item: "about_us" },
    { label: "Services", item: "services" },
  ];

  function goTo(item) {
    appContext.navTo({ item });
  }

  function getActive(item) {
    if (item === "home") {
      return !appContext.navItem || appContext.navItem === "home";
    }

    return appContext.navItem === item;
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="container topbar-shell">
          <button className="topbar-brand" type="button" onClick={() => goTo("home")}>
            <span className="topbar-brand-mark">
              <img src={logo} alt="Nova Technologies logo" className="topbar-brand-logo" />
            </span>
            <span className="topbar-brand-copy">
              <span className="topbar-brand-title mDesktopOnly">NOVA TECHNOLOGIES</span>
            </span>
          </button>

          <div className="topbar-nav-surface DesktopMenu">
            {navItems.map((navItem) => (
              <button
                key={navItem.item}
                type="button"
                className="mMenuItem topbar-link"
                data-active={getActive(navItem.item)}
                onClick={() => goTo(navItem.item)}
              >
                {navItem.label}
              </button>
            ))}

            <button type="button" className="topbar-cta ms-2" onClick={() => goTo("contact_us")}>
              Contact Us
            </button>
          </div>

          <button
            type="button"
            className="topbar-menu-trigger"
            onClick={appContext.openSideBar}
            aria-label="Open menu"
            aria-expanded={appContext.isSideBarOpen}
          >
            <MdMenu size={28} />
          </button>
        </div>
      </div>
    </div>
  );
}
